import { LogLevel } from '@azure/msal-browser';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export enum Environment {
  Local = 'loc',
  Development = 'dev',
  Test = 'test',
  Uat = 'uat',
  Production = 'prod'
}

export const environmentMonikerRegex: RegExp = /https?:\/\/[a-zA-Z\d-]+?(-dev|-test|-uat)?\./;

export function getEnvironment(): Environment {
  const url: string = window.location.href;

  if (url.includes('localhost')) {
    return Environment.Local;
  }

  const matches: RegExpMatchArray | null = url.match(environmentMonikerRegex);

  if (!matches) {
    throw new Error('Could not parse URL to retrieve environment');
  }

  const environmentMoniker: string | undefined = matches[1];

  switch (environmentMoniker) {
    case '-dev':
      return Environment.Development;
    case '-test':
      return Environment.Test;
    case '-uat':
      return Environment.Uat;
    case undefined: // No suffix = Production
      return Environment.Production;
    default:
      throw new Error(`Unrecognized environment moniker: ${environmentMoniker}`);
  }
}
